"use client";

import Image from "next/image";
import { useState } from "react";
import Close from "@/public/icon/close.svg";
import QuantitySelector from "@/components/Quantity/Quantity";
import { useCheckout } from "@/hooks/useCheckout";

const AddToCartPopup = ({ product, t }) => {
  const [closeActive, setCloseActive] = useState(true);
  const [volume_id, setVolume] = useState(product.volumes[0].id);
  const [count, setCount] = useState(1);

  const { addToCart } = useCheckout();

  const close = () => {
    setCloseActive(false);
  };

  const changeVolume = (e) => {
    setVolume(e.target.value);
  };

  // Handle add to cart
  const handleAddToCart = () => {
    addToCart({
      product_id: product.id,
      volume_id: volume_id,
      count: count,
      succesMessage: t["success.message"],
      errorMessage: t["error.title"],
    });
    setCloseActive(false);
  };

  return closeActive ? (
    <div className="popupCart">
      <div className="popupCartInner">
        <div className="productCardPopup">
          <div className="productCardPopupChild">
            <div className="img-container">
              <Image
                src={
                  product.title_image?.main ||
                  product.title_image?.slider ||
                  product.title_image?.thumbnail
                }
                alt="product img"
                width={300}
                height={300}
                quality={90}
              />
            </div>
            <button className="closeButton" onClick={close}>
              <Close />
            </button>
            <div className="productPopupDetail">
              <h2>{product.title}</h2>
              <div className="productDetailSize">
                {product.volumes.map((volume, index) => (
                  <label htmlFor="" key={volume.id}>
                    <input
                      type="radio"
                      name="size"
                      onChange={(e) => changeVolume(e)}
                      value={volume.id}
                      className="volumeItem"
                      defaultChecked={index === 0}
                    />
                    <div className="sizeCard">
                      <span>{volume.volume}</span>
                      {product.price_sale !== product.price ? (
                        <div className="price">
                          {volume.price}₼<span>{volume.sale_price}₼ </span>
                        </div>
                      ) : (
                        <div className="price">{volume.price}₼</div>
                      )}
                    </div>
                  </label>
                ))}
              </div>
            </div>
          </div>
          <div className="productDetailQuantityPopup">
            <QuantitySelector count={count} onChange={setCount} />
            <button
              type="button"
              className="addToCard blackButton"
              onClick={handleAddToCart}
            >
              {t["buttons.add_to_basket"]}
            </button>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default AddToCartPopup;
